module.exports = __webpack_public_path__ + "img/szxfz.8f4d96ea.jpg";